__turbopack_context__.v({
  "avatarContainer": "OrganizerData-module-scss-module__DNpS7G__avatarContainer",
  "contentContainer": "OrganizerData-module-scss-module__DNpS7G__contentContainer",
  "organizerName": "OrganizerData-module-scss-module__DNpS7G__organizerName",
  "wrapper": "OrganizerData-module-scss-module__DNpS7G__wrapper",
});
